import { numbro } from '../singleton/numbro';

/**
 * Хук useNumbro для настройки локализации библиотеки numbro.
 *
 * Данный хук устанавливает язык форматирования чисел с использованием библиотеки numbro
 * и возвращает объект numbro, настроенный на выбранную локализацию.
 *
 * Переменные:
 * - locale: строка, представляющая код локали, на которую будет настроена библиотека numbro.
 *
 * Возвращает:
 * Объект numbro, настроенный с использованием указанной локализации.
 */
export const useNumbro = () => {
  const locale = 'ru-RU';
  numbro.setLanguage(locale);
  return numbro;
};
